import { Link, useNavigate } from "react-router-dom";
import Image from "../images/Image";
import Button from "../buttons/Button";
import useTranslation from "../CustomHooks/useTranslation";
import { breadcrumbsContent } from "./BreadcrumbsContent";
import { useSelector } from "react-redux";

interface BreadcrumbsProps {
  navPath: string[];
  heading: string;
  noNavigation?: boolean;
  button?: {
    buttonName: string;
    className?: string;
    buttonOnclick: () => void; // Corrected function type
  };
  secondaryButton?: {
    buttonName: string;
    className?: string;
    buttonOnclick: () => void; // Corrected function type
  };
  hasAddPrivilege?: boolean;
  backButtonNavigation?: string
  links?: (string | number)[] | ((value: boolean) => void);
  upfront?: boolean;
  list?: boolean;
  setAddClicked?: (value: boolean) => void;
}
export default function Breadcrumbs({ noNavigation, navPath, button, heading, links = [], backButtonNavigation, secondaryButton, hasAddPrivilege = true, upfront, list, setAddClicked }: BreadcrumbsProps) {
  const navigate = useNavigate();
  const { translate, notEnglish } = useTranslation(breadcrumbsContent)
  const record = useSelector((state: any) => state.list);
 
  return (
    <div className={`${((heading.includes('Distributors') || (heading.includes('Customers')) || heading.includes('View On Target Achievement') || heading.includes('Agents') || heading.includes('Retailers') || heading.includes('List of Onboarding Request') || heading.includes('List of E Top Up Request Raised') || heading.includes("List of Companies")) && record && record.recordCount > 0 && !record.error) ? 'pl-3 pr-[34px]' : (heading.includes('Admins') && !record) ? 'mr-[-30px]' : (heading.includes('Admins') && record ) ? 'px-3 pr-[34px]' : 'px-3'} pt-3`}>
      <div className="bg-white h-[86px] rounded-lg py-2.5 px-6 flex justify-between items-center" dir={`${notEnglish ? 'rtl' : 'ltr'}`}>
        <div>
          <div className="flex items-center gap-2.5">
            {backButtonNavigation && <Image src="Back" className='cursor-pointer' onClick={() => navigate(backButtonNavigation)} />}
            <h1 className="text-heading2 text-primary_text">{translate(heading)}</h1>
          </div>
          <div className="flex mt-2">
            {navPath.map((item, index) => (
              <div className="flex items-center" key={`${index}-breadCrumbs`}>
                {!list ? <p
                  className={`${index !== navPath.length - 1 ? "text-p_primary cursor-pointer" : ""
                    } text-body2  ${links.length === 0 ? '' : ''}`}
                  onClick={() => {
                    if (item === 'View Details' && setAddClicked) {
                      setAddClicked(false);
                    }
                    if (!noNavigation) {
                      links[index] === 'back' ? navigate(-1) : navigate(links[index]);
                    }
                  }}
                  data-testid={`${item.replace(/ /g, '_').toLocaleLowerCase()}`}                   >
                  {translate(item)}{" "}
                </p> : <p
                  className={`${index !== navPath.length - 1 ? "text-p_primary " : ""
                    } text-body2 `}
                  data-testid={`${item.replace(/ /g, '_').toLocaleLowerCase()}`}                   >
                  {translate(item)}{" "}
                </p>}
                {navPath.length !== index + 1 && (
                  <Image src={`${notEnglish ? 'page-light-right' : 'page-light-left'}`} />
                )}
              </div>
            ))}
          </div>
        </div>
        
        <div className="flex items-center gap-2.5 pr-1.5">
          {upfront && (
            <Button
              buttonName={translate(secondaryButton?.buttonName || "")}
              className={` ${secondaryButton?.className} border border-p_primary rounded-lg `}
              buttonOnclick={secondaryButton?.buttonOnclick}
              testId={secondaryButton?.buttonName.replace(' ', '_').toLocaleLowerCase()}
              bgColor='bg-white'
              textColor='text-p_primary'
              buttonHight="h-[45px]"
            textSize="text-small"
            />
          )}
          {(button && hasAddPrivilege) && (
          <Button
            buttonName={translate(button.buttonName)}
            className={button.className}
            buttonOnclick={button.buttonOnclick}
            testId={button.buttonName.replace(' ', '_').toLocaleLowerCase()}
            buttonHight="h-[45px]"
            textSize="text-small"
          />
        )}
        </div>
      </div>
    </div>
  );
}